/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Image, Link } from '@ta-interaktiv/contentbricks'
import { FamilyTree } from 'components/familyTree'

const isMobile = window.innerWidth < 599

// TODO Set the correct article ID here
const ARTICLE_ID = '00000000'

export function AppComponent() {
  return (
    <>
      <div className='index'>
        <ThemeSwitch />

        <h4 className='graphicTitle'>
          Stammbaum Familie Hoffmann-La&nbsp;Roche
        </h4>
        <div className='introWrapper'>
          {isMobile ? (
            <div className='hint'>
              <Image
                file={require('../../images/touch-gesture-icon.svg')}
                className='cbImage iconTouch'
              />

              <div>Navigieren Sie durch den Stammbaum</div>
            </div>
          ) : (
            ''
          )}

          <div className='legend'>
            <div className='circle' />
            <div>Blutlinie</div>
          </div>
        </div>

        <FamilyTree />
        <div className='foot'>
          <p className='source'>
            Quelle: Eigene Recherche / Grafik: pvo
          </p>
        </div>
      </div>
    </>
  )
}
